var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.3,
    height: 17,
    viewBox: "0 0 15.3 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "date",
    d: "M9.6,10.65H7.9v1.7H9.6Zm3.4,0H11.3v1.7H13Zm3.4,0H14.7v1.7h1.7ZM18.1,4.7h-.85V3h-1.7V4.7H8.75V3H7.05V4.7H6.2A1.692,1.692,0,0,0,4.509,6.4L4.5,18.3A1.7,1.7,0,0,0,6.2,20H18.1a1.7,1.7,0,0,0,1.7-1.7V6.4A1.7,1.7,0,0,0,18.1,4.7Zm0,13.6H6.2V8.95H18.1Z",
    transform: "translate(-4.5 -3)",
    fill: "#33d1eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.71a3059fd3603a5af2ff711d6cc496ef.svg";
export { ForwardRef as ReactComponent };